'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _match = require('./match');

var _match2 = _interopRequireDefault(_match);

var _parse = require('./parse');

var _parse2 = _interopRequireDefault(_parse);

var _parseHTML = require('./parseHTML');

var _parseHTML2 = _interopRequireDefault(_parseHTML);

exports['default'] = {
  match: _match2['default'],
  parse: _parse2['default'],
  parseHTML: _parseHTML2['default']
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/autosuggest-highlight/dist/autosuggest-highlight.js
 ** module id = 802
 ** module chunks = 0
 **/